{
  "metadata": {
    "id": "solarized-light",
    "name": "Solarized",
    "description": "Портировано из темы «Solarized» (light)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "light",
    "tags": [
      "light",
      "ported"
    ],
    "source": {
      "file": "solarized.json",
      "project": "altercation",
      "url": "https://github.com/altercation/solarized",
      "upstreamFile": "packages/ui/src/theme/themes/solarized.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 28.6,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.457,
      "paletteMaxS": 0.532,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 8.1,
      "surfacesTarget": 8.0,
      "surfacesRaisedTarget": 10.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 18.2,
      "syntaxVsTextMinDeltaE": 8.9,
      "chartsMinDeltaE": 24.3,
      "textSeparationDeltaE": 10.4,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [],
      "modeLabel": "light",
      "modeFromLuminance": "light",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#268bd2",
      "hover": "#227dbd",
      "active": "#1f72ac",
      "foreground": "#000000",
      "muted": "#268bd280",
      "emphasis": "#268bd2"
    },
    "surface": {
      "background": "#fdf6e3",
      "foreground": "#293337",
      "muted": "#caccc2",
      "mutedForeground": "#414948",
      "elevated": "#b0b7b1",
      "elevatedForeground": "#39484c",
      "raised": "#929e9d",
      "raisedForeground": "#2a3538",
      "overlay": "#fdf6e333",
      "subtle": "#e3e1d2"
    },
    "interactive": {
      "border": "#889595",
      "borderHover": "#c3c5b6",
      "borderFocus": "#268bd2",
      "selection": "#586e7524",
      "selectionForeground": "#586e75",
      "focus": "#268bd259",
      "focusRing": "#268bd247",
      "cursor": "#586e75",
      "hover": "#586e7517",
      "active": "#586e7524"
    },
    "status": {
      "error": "#d72724",
      "errorForeground": "#ffffff",
      "errorBackground": "#d727241a",
      "errorBorder": "#d7272459",
      "warning": "#8c6a00",
      "warningForeground": "#ffffff",
      "warningBackground": "#8c6a001a",
      "warningBorder": "#8c6a0059",
      "success": "#667500",
      "successForeground": "#ffffff",
      "successBackground": "#6675001a",
      "successBorder": "#66750059",
      "info": "#217d76",
      "infoForeground": "#ffffff",
      "infoBackground": "#217d761a",
      "infoBorder": "#217d7659"
    },
    "pr": {
      "open": "#667500",
      "draft": "#4e5856",
      "blocked": "#8c6a00",
      "merged": "#d33682",
      "closed": "#d72724"
    },
    "syntax": {
      "base": {
        "background": "#caccc2",
        "foreground": "#586e75",
        "comment": "#48585e",
        "keyword": "#4b5800",
        "string": "#145d58",
        "number": "#9b225c",
        "function": "#195a89",
        "variable": "#46585e",
        "type": "#8c2400",
        "operator": "#0c0e0d"
      },
      "tokens": {
        "commentDoc": "#48585e",
        "stringEscape": "#0c0e0d",
        "keywordImport": "#4b5800",
        "storageModifier": "#4b5800",
        "functionCall": "#195a89",
        "method": "#195a89",
        "variableProperty": "#195a89",
        "variableOther": "#46585e",
        "variableGlobal": "#9b225c",
        "variableLocal": "#0c0e0d",
        "parameter": "#46585e",
        "constant": "#9b225c",
        "class": "#8c2400",
        "className": "#8c2400",
        "interface": "#8c2400",
        "struct": "#8c2400",
        "enum": "#8c2400",
        "typeParameter": "#8c2400",
        "namespace": "#8c2400",
        "module": "#4b5800",
        "tag": "#4b5800",
        "jsxTag": "#4b5800",
        "tagAttribute": "#195a89",
        "tagAttributeValue": "#145d58",
        "boolean": "#9b225c",
        "decorator": "#4b5800",
        "label": "#195a89",
        "regexp": "#145d58"
      }
    },
    "charts": {
      "series": [
        "#268bd2",
        "#217d76",
        "#667500",
        "#8c6a00",
        "#d72724"
      ]
    },
    "chat": {
      "background": "#fdf6e3",
      "userMessage": "#39484c",
      "userMessageBackground": "#b0b7b1",
      "assistantMessage": "#46585e",
      "assistantMessageBackground": "#caccc2",
      "timestamp": "#4e5856",
      "divider": "#889595",
      "typing": "#4e5856"
    },
    "loading": {
      "spinner": "#268bd2",
      "spinnerTrack": "#caccc2",
      "skeleton": "#caccc2",
      "shimmer": "#c3c6bd"
    },
    "tools": {
      "background": "#caccc2",
      "border": "#889595",
      "headerHover": "#c4c7be",
      "icon": "#2074af",
      "title": "#586e75",
      "description": "#4e5856",
      "edit": {
        "added": "#667500",
        "addedBackground": "#6675001a",
        "removed": "#d72724",
        "removedBackground": "#d727241a",
        "modified": "#217d76",
        "modifiedBackground": "#217d761a",
        "lineNumber": "#4e5856"
      }
    },
    "markdown": {
      "heading1": "#586e75",
      "heading2": "#586e75",
      "heading3": "#586e75",
      "heading4": "#586e75",
      "link": "#2074af",
      "linkHover": "#2074b0",
      "inlineCode": "#145d58",
      "inlineCodeBackground": "#caccc2",
      "blockquote": "#4e5856",
      "blockquoteBorder": "#889595",
      "listMarker": "#2588ce",
      "bold": "#586e75",
      "italic": "#586e75e6",
      "strikethrough": "#4e5856",
      "hr": "#889595"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#8a3945",
        "foreground": "#ffffff",
        "contrast": 7.63
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#c56f54",
        "foreground": "#000000",
        "contrast": 5.78
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#ceab85",
        "foreground": "#000000",
        "contrast": 9.79
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#d9d986",
        "foreground": "#000000",
        "contrast": 14.22
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#75973f",
        "foreground": "#000000",
        "contrast": 6.25
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#60ca5d",
        "foreground": "#000000",
        "contrast": 10.1
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#84d79d",
        "foreground": "#000000",
        "contrast": 12.19
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#438e73",
        "foreground": "#000000",
        "contrast": 5.36
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#84d4d7",
        "foreground": "#000000",
        "contrast": 12.38
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#579ac5",
        "foreground": "#000000",
        "contrast": 6.83
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#364f88",
        "foreground": "#ffffff",
        "contrast": 7.98
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#30379d",
        "foreground": "#ffffff",
        "contrast": 9.73
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#9e80c9",
        "foreground": "#000000",
        "contrast": 6.38
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#a954c3",
        "foreground": "#000000",
        "contrast": 4.74
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#8a3b78",
        "foreground": "#ffffff",
        "contrast": 7.05
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#cc819c",
        "foreground": "#000000",
        "contrast": 7.19
      }
    ]
  }
}
